import { Component, computed, inject, output, ChangeDetectionStrategy } from '@angular/core';
import { IonButton } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import {
  EmptyResultComponent,
  SkeletonCardInprogressComponent,
  SpinnerLoadingComponent,
} from '@okcargo-apps/layout-ionic';
import { AccountService } from '../../account';
import { FreightAvailableCardGoToListCtaComponent } from '../../freight-available/freight-available-card-go-to-list-cta/freight-available-card-go-to-list-cta.component';
import { ECapabilities } from '@okcargo-apps/shared-domain-ionic';
import { DateFnsModule } from 'ngx-date-fns';
import { FreightCarrierStoreService } from '../freight-carrier-store.service';
import { FreightCarrierInprogressCardComponent } from '../freight-carrier-inprogress-card/freight-carrier-inprogress-card.component';

@Component({
  selector: 'lib-freight-carrier-inprogress-list-dashboard',
  templateUrl: './freight-carrier-inprogress-list-dashboard.component.html',
  styleUrls: ['./freight-carrier-inprogress-list-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonButton,
    FreightCarrierInprogressCardComponent,
    EmptyResultComponent,
    FreightAvailableCardGoToListCtaComponent,
    TranslateModule,
    DateFnsModule,
    SkeletonCardInprogressComponent,
    SpinnerLoadingComponent,
  ],
})
export class FreightCarrierInprogressListDashboardComponent {
  private readonly freightCarrierStoreService = inject(FreightCarrierStoreService);
  private readonly accountService = inject(AccountService);

  private readonly vm = this.freightCarrierStoreService.inProgressTodayList;

  protected readonly loading = computed(() => this.vm().isLoading);

  protected readonly freights = computed(() => this.vm().items);

  protected readonly hasMore = computed(() => this.vm().totalElements > this.vm().items.length);

  protected readonly hasViewMarketCapability = computed(() =>
    this.accountService.account().capabilities.includes(ECapabilities.VIEW_MARKET),
  );

  public readonly seeMore = output<void>();

  protected today: Date = new Date();
}
